import * as React from "react"
import type { IconProps } from "../types"

const MinusMini = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M6.75 12H17.25"
        />
      </svg>
    )
  }
)
MinusMini.displayName = "MinusMini"

export default MinusMini
